const portType = () => ({
  SEA_PORT: 1,
  DRY_PORT: 2,
  AIR_PORT: 3,
  BORDER_PORT: 4,
});

const portMapping = {
  SEA_PORT: 'Sea',
  DRY_PORT: 'Dry',
  BORDER_PORT: 'Border',
  AIR_PORT: 'AIR',
};

const validPortHeaders = {
  Name: 'name',
  'Short Code': 'short_code',
  'Ref Id': 'reference_id',
  Country: 'country',
  Pincode: 'pin_code',
  'Geo Code': 'geo_code',
  Type: 'type',
  City: 'city',
  State: 'state',
  Address: 'address',
};

module.exports = {
  portType,
  validPortHeaders,
  portMapping,
};
